import  Row from 'react-bootstrap/Row';
import styled from "styled-components";


export const LoadingStyles = styled(Row)`
.lds-ring {
  display: inline-block;
  position: fixed;
  width: 50px;
  height: 50px;
  top: 40%;
  margin-left:-70px;
}
.lds-ring div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 64px;
  height: 64px;
  margin: 8px;
  border: 8px solid #fff;
  border-radius: 50%;
  animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: #fff transparent transparent transparent;
}
.lds-ring div:nth-child(1) {
  animation-delay: -0.45s;
}
.lds-ring div:nth-child(2) {
  animation-delay: -0.3s;
}
.lds-ring div:nth-child(3) {
  animation-delay: -0.15s;
}
@keyframes lds-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@media screen and (max-width: 990px){
  .lds-ring {
    top: 30%;
    left:54%;
  }
}
`;